module.exports = __webpack_public_path__ + "4ffa2be686b19555893e4f126ab5fb52.pdf";